module.exports = __webpack_public_path__ + "static/media/pauseSmall.737c797e.svg";